enum UserRedirectsEnum {
  ONLINE_CARD = 'online-card',
  AUTHENTICATE_ATTESTATION = 'authenticate-attestation',
  MOVEMENT_BY_SCREEN = 'movement-by-screen',
  INCOME_REPORT = 'income-report',
  INVOICE_ORDER_NUMBER = 'invoice-order-number',
  OPERATING_COST_REPORT = 'operating-cost-report',
  MORE_SERVICES = 'more-services',
  MONTHLY_FEE_PREVIEW_REPORT = 'monthly-fee-preview-report',
  REVIEWS_SCREEN_MOVEMENT = 'reviews-screen-movement',
  MOVEMENT_STATUS = 'movement-status',
  SUSPENDED_BENEFICIARY = 'suspended-beneficiary',
  BILLING = 'billing',
  COPARTICIPATION_PREVIEW_REPORT = 'coparticipation-preview-report',
  BILLING_TOP_SAUDE = 'billing-top-saude',
  BENEFICIARIES = 'beneficiaries',
  MOVEMENT_SCREEN_INCLUDE_BENEFICIARY = 'movement-screen-include-beneficiary',
  MOVEMENT_SCREEN_CANCEL_INCLUDE_BENEFICIARY = 'movement-screen-cancel-include-beneficiary',
  MOVEMENT_SCREEN_CHANGE_INCLUDE_BENEFICIARY = 'movement-screen-change-include-beneficiary',
  MOVEMENT_SCREEN_CHANGE_UNIT_INCLUDE_BENEFICIARY = 'movement-screen-change-unit-include-beneficiary',
  MOVEMENT_SCREEN_INCLUDE_DEPENDENT = 'movement-screen-include-dependent',
  MOVEMENT_SCREEN_MARRIAGE_INCLUDE_DEPENDENT = 'movement-screen-marriage-include-dependent',
  MOVEMENT_SCREEN_BIRTH_INCLUDE_DEPENDENT = 'movement-screen-birth-include-dependent',
  MOVEMENT_SCREEN_CANCEL_INCLUDE_DEPENDENT = 'movement-screen-cancel-include-dependent',
  MOVEMENT_SCREEN_CHANGE_INCLUDE_DEPENDENT = 'movement-screen-change-include-dependent',
  MOVEMENT_SCREEN_NEW_PRE_CANCELLATION_BENEFICIARY = 'movement-screen-new-pre-cancellation-beneficiary',
  MOVEMENT_SCREEN_CANCEL_PRE_CANCELLATION_BENEFICIARY = 'movement-screen-cancel-pre-cancellation-beneficiary',
  MOVEMENT_SCREEN_NEW_PRE_CANCELLATION_DEPENDENT = 'movement-screen-new-pre-cancellation-dependent',
  MOVEMENT_SCREEN_CANCEL_PRE_CANCELLATION_DEPENDENT = 'movement-screen-cancel-pre-cancellation-dependent',
  MOVEMENT_SCREEN_MAJORITY_CONTROL_PRE_CANCELLATION_DEPENDENT = 'movement-screen-majority-control-pre-cancellation-dependent',
  MOVEMENT_SCREEN_SUSPEND_PRE_CANCELLATION = 'movement-screen-suspend-pre-cancellation',
  MOVEMENT_SCREEN_CHANGE_PLAN_BENEFICIARY = 'movement-screen-change-plan-beneficiary',
  MOVEMENT_SCREEN_CHANGE_UNIT_BENEFICIARY = 'movement-screen-change-unit-beneficiary',
  MOVEMENT_SCREEN_CHANGE_DATA_BENEFICIARY = 'movement-screen-change-data-beneficiary',
  MOVEMENT_SCREEN_CANCEL_CHANGE_DATA_BENEFICIARY = 'movement-screen-cancel-change-data-beneficiary',
  MOVEMENT_SCREEN_CHANGE_DATA_DEPENDENT = 'movement-screen-change-data-dependent',
  MOVEMENT_SCREEN_CANCEL_CHANGE_DATA_DEPENDENT = 'movement-screen-cancel-change-data-dependent',
  MOVEMENT_SCREEN_INCLUDE_PENDING_REQUEST_AUTHORIZATION = 'movement-screen-include-pending-request-authorization',
  MOVEMENT_SCREEN_EXCLUDE_PENDING_REQUEST_AUTHORIZATION = 'movement-screen-exclude-pending-request-authorization',
  MOVEMENT_SCREEN_INCLUDE_TRANSFER = 'movement-screen-include-transfer',
  MOVEMENT_SCREEN_CANCEL_TRANSFER = 'movement-screen-cancel-transfer',
  MOVEMENT_SCREEN_SUSPEND_MEDICAL_CARE = 'movement-screen-suspend-medical-care',
  MOVEMENT_SCREEN_REACTIVATE_MEDICAL_CARE = 'movement-screen-reactivate-medical-care',
  MOVEMENT_SCREEN_CANCEL_REQUEST_SUSPENDED_BENEFICIARIES = 'movement-screen-cancel-request-suspended-beneficiaries',
}

interface RedirectUserResponseDTO {
  content: string;
}

export { type RedirectUserResponseDTO, UserRedirectsEnum };
